import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { MaskLines, Reveal } from "./Reveal";

export const CTABand = () => (
  <section data-testid="final-cta" className="relative overflow-hidden bg-[#0E2657] py-28 sm:py-36 grain">
    <div className="grid-lines absolute inset-0" />
    <div className="absolute left-1/2 top-1/2 h-[520px] w-[820px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1777AF]/25 blur-[140px]" />
    <div className="container-x relative">
      <p className="eyebrow text-cyan-400">Next step</p>
      <MaskLines
        lines={["Ready for", { text: "peace of mind?", className: "text-grad" }]}
        className="mt-6 font-display text-5xl font-bold leading-[0.98] tracking-tight text-white sm:text-7xl lg:text-8xl"
      />
      <Reveal delay={0.2} className="mt-10 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <p className="max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
          Book a free 30-minute consultation. We'll review your IT, dispatch and onsite needs — and give you a simple, very reasonable quote.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link to="/contact" data-testid="final-cta-consult-button" className="btn-primary">
            Get a Free Consultation <ArrowUpRight className="h-4 w-4" />
          </Link>
          <Link to="/solutions" data-testid="final-cta-solutions-button" className="btn-ghost border-white/20 text-white hover:border-cyan-300 hover:text-cyan-300">
            Explore Solutions
          </Link>
        </div>
      </Reveal>
      <p className="mt-10 flex items-center gap-2 text-sm text-slate-400">
        <Clock className="h-4 w-4 text-cyan-400" /> We reply within one business day.
      </p>
    </div>
  </section>
);
